<template >
  <base-dialog-form :type="type" ref="editDocumentoDialog" :title="computedTitle" color="secondary"
    icon="mdi-file-document-outline">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-col v-if="computedRequired" cols="12">
            <h3 class="error--text">{{ computedRequired }}</h3>
          </v-col>
          <data-tables :headers="headers" :table-data="tableData" @showDocument="showDocument"
            @deleteDocument="deleteDocument" @approveDocument="approveDocument" @rejectDocument="rejectDocument" />
        </v-col>
      </v-row>
    </v-container>
    <v-form ref="form" v-model="valid" lazy-validation v-if="method !== 'APPROVE'">
      <v-container>
        <v-row>
          <v-col cols="12">
            <base-material-card color="secondary" icon="mdi-upload" :title="$t('upload_document')">
              <document-uploader :types="docTypes" :required="docRequired" @uploaded="emitUpload" :url="uploadUrl" />
            </base-material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="toApprove" cols="12" class="text-center">
            <v-banner single-line>
              <v-icon slot="icon" color="warning" size="36">mdi-alert-outline</v-icon>
              <h2 class="warning--text">
                {{ $t("data_waiting_for_approvation") }}
              </h2>
            </v-banner>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import documentUploader from "@/widget/documentUploader.vue";
import DataTables from "@/components/base/DataTables.vue";

export default {
  name: "edit-documenti",
  props: {
    parmsMethod: null,
    parmsAsdCode: null,
    parmsMode: null,
    type: {
      type: String, // not 'string'
      required: false,
      default: "dialog",
    },
  },
  components: {
    MyDatepicker,
    DataTables,
    documentUploader,
  },
  computed: {
    uploadUrl: function () {
      return "/auth/ente/uploadDocument";
    },
    computedTitle: function () {
      if (this.method === "APPROVE" && this.ifEnte)
        return this.$t("approve_asd_documents")+" "+this.code;
      else if (this.method === "EDIT") return this.$t("manage_asd_documents")+" "+this.code;
      else if (this.method === "VIEW") return this.$t("view_asd_documents")+" "+this.code;
      else return "";
    },
    computedRequired: function () {
      let _ = this;
      if (_.docRequired && _.docRequired.length > 0 && _.tableData && _.tableData.length > 0) {
        let docRequired = []
        for (let required of _.docRequired) {
          let presente = _.tableData.find(el => {
            return el.type === required && new Date(el.dateInz) <= new Date() && new Date(el.dateEnd) >= new Date()
          })
          if (!presente) docRequired.push(required)
        }
        if (docRequired.length > 0) return _.$t("missing_document") + ": " + docRequired.join(", ")
      }
      else return null;
    },
  },
  data() {
    return {
      method: null,
      code: null,
      mode: null,
      headers: [],
      tableData: [],
      docTypes: [],
      docRequired: [],
      currentDocumento: [],
      selectedDocumento: null,
      valid: false,
      ifEnte: false,
      toApprove: null,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    emitUpload(item) {
      this.loadData();
    },
    open(method, code) {
      this.method = method;
      this.code = code;
      this.loadData();
      this.$refs.editDocumentoDialog.open();
    },
    loadData() {
      let _ = this;
      let code = systemData.ASD.code;
      _.ifEnte = false;
      if (_.code) code = _.code;
      _.headers = [
        { text: this.$t("date_inz"), value: "dateInz", type: "date" },
        { text: this.$t("date_end"), value: "dateEnd", type: "date" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("description"), value: "text" },
        { text: this.$t("validated"), value: "icons", type: "icons" },
        { text: this.$t("active"), value: "active_icon", type: "icons" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ];
      _.tableData = [];
      _.chiamataAxios("POST", "/auth/ente/listDocumenti/" + code).then(
        (response) => {
          _.docRequired = response.data.typeRequired;
          _.docTypes = response.data.type;
          _.ifEnte = response.data.ifEnte;
          _.tableData = response.data.documenti.map(function (item) {
            item.options = [
              {
                icon: "mdi-magnify",
                function: "showDocument",
                text: _.$t("show_document"),
                color: "green",
              },
            ];
            if (!_.ifEnte && item.status !== 1) {
              item.options.push({
                icon: "mdi-delete",
                function: "deleteDocument",
                text: _.$t("delete_document"),
                color: "red",
              });
            }
            if (_.ifEnte && _.method === "APPROVE" && item.status === 0) {
              item.options.push({
                icon: "mdi-thumb-up-outline",
                function: "approveDocument",
                text: _.$t("approve"),
                color: "orange",
              });
              item.options.push({
                icon: "mdi-thumb-down-outline",
                function: "rejectDocument",
                text: _.$t("reject"),
                color: "orange",
              });
            }

            if (new Date(item.dateInz) <= new Date() && new Date(item.dateEnd) >= new Date()) item.active_icon = [{ icon: "mdi-check", color: "green" }];
            else item.active_icon = [{ icon: "mdi-close", color: "red" }];

            switch (item.status) {
              case 1:
                item.icons = [
                  { icon: "mdi-file-check-outline", color: "green" },
                ];
                break;
              case -1:
                item.icons = [
                  { icon: "mdi-file-remove-outline", color: "red" },
                ];
                break;
              default:
                item.icons = [
                  { icon: "mdi-file-question-outline", color: "blue" },
                ];
            }

            return item;
          });
        }
      );
    },
    approveDocument(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_approve"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "PUT",
            "/auth/ente/approveDocumento/" + _.code + "/" + item.docId,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + _.$t("data_approved") + "</strong>";
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
    showDocument(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.url;
    },
    rejectDocument(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_reject"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/ente/rejectDocumento/" + _.code + "/" + item.docId,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
    deleteDocument(item) {
      let _ = this;

      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/ente/deleteDocumento/" + item.docId,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.selectedDocumento = null;
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
  },
  created() { },
  mounted() {
    this.ifEnte = window.systemData.ifEnte;
    if (this.parmsAsdCode) this.code = this.parmsAsdCode;
    if (this.parmsMethod) this.method = this.parmsMethod;
    if (this.parmsMode) this.mode = this.parmsMode;
    this.loadData();
  },
  watch: {
    parmsAsdCode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.code = newVal;
    },
    parmsMethod: function (newVal, oldVal) {
      // watch it
      if (newVal) this.method = newVal;
    },
    parmsMode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.mode = newVal;
    },
    code: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>